module.exports = __webpack_public_path__ + "static/media/logo8.908de490.png";